/** Full-bleed black-and-white photo with a gradient overlay; children sit in the site container. */
export default function PhotoBanner({ id, labelledBy, image, alt, overlay, className = '', children }) {
  return (
    <section id={id} aria-labelledby={labelledBy} className={`relative overflow-hidden bg-ink text-bg ${className}`}>
      <div aria-hidden="true" className="bw-strong absolute inset-0">
        <img src={image} alt={alt} loading="lazy" className="h-full w-full object-cover" />
      </div>
      <div aria-hidden="true" className="absolute inset-0" style={{ background: overlay }} />
      <div className="container-site relative">{children}</div>
    </section>
  );
}
